import PropTypes from 'prop-types'
import { Label } from '@components/ui/label'
import { cn } from 'lib/utils'

export const AdasFormControlLabel = ({
  control,
  label,
  className,
  disabled,
  labelPlacement = 'end',
  // eslint-disable-next-line no-unused-vars
  sx,
  // eslint-disable-next-line no-unused-vars
  value,
  ...props
}) => (
  <div className={cn('flex items-center gap-2', labelPlacement === 'start' && 'flex-row-reverse', className)} {...props}>
    {control}
    <Label className={cn('text-sm cursor-pointer', disabled && 'opacity-50')}>{label}</Label>
  </div>
)

AdasFormControlLabel.propTypes = {
  control: PropTypes.node,
  label: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  labelPlacement: PropTypes.string
}
